export default __webpack_public_path__ + "static/media/tic-tac-toe-sc.af3b86fd.jpg";